import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import MetisMenu from "react-metismenu";
import { setEnableMobileMenu } from "../../store/reducers/ThemeOptions";
import { PropertiesManagerNav, VerificationRequestNav, DashboardNav, UsersNav, AdvertisementManageNav, MastersNav, LandmarksNav, SettingsNav } from "./NavItems";

class Nav extends Component {
  state = {
    filteredMenus: {
      DashboardNav: [],
      PropertiesManagerNav: [],
      VerificationRequestNav: [],
      UsersNav: [],
      AdvertisementManageNav: [],
      MastersNav: [],
      LandmarksNav: [],
      SettingsNav: []
    }
  };

  componentDidMount() {
    const { userData } = this.props;
    if (userData?.myRight) {
      this.filterMenus(userData.myRight);
    }
  }

  componentDidUpdate(prevProps) {
    const { userData } = this.props;
    const { rights } = this.props;
    if (userData?.myRight !== prevProps.userData?.myRight) {
      this.filterMenus(userData.myRight);
    }
  }

  filterMenus = (myRight) => {
    const filterNav = (navItems) =>
    navItems.filter((item) => {
      const lastSegment = item.to?.split("/").pop();
      if (lastSegment === "logout") return true;
      if (lastSegment === "myrights") return true;
      if (lastSegment === "passwordreset") return true;
      if (lastSegment === "profile") return true;

      return (lastSegment === "list") 
      ? myRight.some((right) => 'landmarks' === right.routs_name) 
      : myRight.some((right) => lastSegment === right.routs_name)
    });

    const loggedIn = JSON.parse(localStorage.getItem("user"));
    // if (loggedIn?.user?.roles_id === 2) {
    //   this.setState({
    //     filteredMenus: {
    //       DashboardNav: DashboardNav,
    //       PropertiesManagerNav: PropertiesManagerNav,
    //       VerificationRequestNav: VerificationRequestNav,
    //       UsersNav: UsersNav,
    //       AdvertisementManageNav: AdvertisementManageNav,
    //       MastersNav: MastersNav,
    //       LandmarksNav: LandmarksNav,
    //       SettingsNav: SettingsNav,
    //     }
    //   });
    // } else {
      this.setState({
        filteredMenus: {
          DashboardNav: filterNav(DashboardNav),
          PropertiesManagerNav: filterNav(PropertiesManagerNav),
          VerificationRequestNav: filterNav(VerificationRequestNav),
          UsersNav: filterNav(UsersNav),
          AdvertisementManageNav: filterNav(AdvertisementManageNav),
          MastersNav: filterNav(MastersNav),
          LandmarksNav: filterNav(LandmarksNav),
          SettingsNav: filterNav(SettingsNav)
        }
      });
    // }
  };

  toggleMobileSidebar = (selectedLinkHref) => {
    const activeLinks = document.querySelectorAll(".metismenu-link.active");
    activeLinks.forEach((link) => {
      const hrefValue = link.getAttribute("href");
      if (hrefValue && !hrefValue.includes(selectedLinkHref)) {
        link.classList.remove("active");
      }
    });
  
    let { enableMobileMenu, setEnableMobileMenu } = this.props;
    setEnableMobileMenu(!enableMobileMenu);
  };
  

  render() {
    const { filteredMenus } = this.state;
    console.log("filteredMenus", filteredMenus);
    const handleSelected = (event) => {
      const selectedLinkHref = event && event.target && event.target.getAttribute("href");
      this.toggleMobileSidebar(selectedLinkHref);
    };

    return (
      <Fragment>
        {filteredMenus.DashboardNav.length > 0 && (
          <>
            <h5 className="app-sidebar__heading">Dashboard</h5>
            <MetisMenu content={filteredMenus.DashboardNav} onSelected={handleSelected} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/>    
          </>
        )}

        {filteredMenus.PropertiesManagerNav.length > 0 && (
          <>
            <h5 className="app-sidebar__heading">Properties Manage</h5>
            <MetisMenu content={filteredMenus.PropertiesManagerNav} onSelected={handleSelected} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/>  
          </>
        )}

        {filteredMenus.VerificationRequestNav.length > 0 && (
          <>
            <h5 className="app-sidebar__heading">Verification Request</h5>
            <MetisMenu content={filteredMenus.VerificationRequestNav} onSelected={handleSelected} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/>  
          </>
        )}

        {filteredMenus.UsersNav.length > 0 && (
          <>
            <h5 className="app-sidebar__heading">Users</h5>
            <MetisMenu content={filteredMenus.UsersNav} onSelected={handleSelected} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/> 
          </>
        )}

        {filteredMenus.AdvertisementManageNav.length > 0 && (
          <>
            <h5 className="app-sidebar__heading">Advertisement Manage</h5>
            <MetisMenu content={filteredMenus.AdvertisementManageNav} onSelected={handleSelected} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/>  
          </>
        )}

        {filteredMenus.MastersNav.length > 0 && (
          <>
            <h5 className="app-sidebar__heading">Masters</h5>
            <MetisMenu content={filteredMenus.MastersNav} onSelected={handleSelected} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/>  
          </>
        )}

        {filteredMenus.LandmarksNav.length > 0 && (
          <>
            <h5 className="app-sidebar__heading">Landmarks</h5>
            <MetisMenu content={filteredMenus.LandmarksNav} onSelected={handleSelected} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/>  
          </>
        )}

        {filteredMenus.SettingsNav.length > 0 && (
          <>
            <h5 className="app-sidebar__heading">Settings</h5>
            <MetisMenu content={filteredMenus.SettingsNav} onSelected={handleSelected} activeLinkFromLocation
              className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/>  
          </>
        )}
      </Fragment>
    );
  }

}
const mapStateToProps = (state) => ({
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  userData: state.auth.userData,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Nav));

